export default "__VITE_ASSET__B4XOpoJ5__"